import React from 'react';
import { Printer } from 'lucide-react';

const PrintMenuButton = ({ label = 'Tulosta viikkolista (A4)' }) => (
  <a
    href="/lounaslista-tulosta"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="print-lunch-menu-btn"
    className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#D9D9D6] text-[#2F2F2F] text-xs font-semibold tracking-wider uppercase hover:border-[#C97A2B] hover:text-[#C97A2B] transition-colors"
  >
    <Printer className="w-4 h-4" /> {label}
  </a>
);

export default PrintMenuButton;
